import tw, { styled } from 'twin.macro';
import Icon from '@/components/Icon/IconAsset';
import Link from '@/components/Link/Link';
import ResponsiveImage from '@/components/ResponsiveImage/ResponsiveImage';

export const StyledContent = styled.div`
  ${tw`container container-stack-context`}
`;

export const StyledInfoContainer = styled.div`
  ${tw`flex flex-col justify-center`};
  ${tw`w-full`};
  ${tw`col-span-4 lg:col-start-1 lg:col-span-5`};
`;

export const StyledIcon = styled(Icon)`
  ${tw`w-64 h-8`}
  ${tw`text-[transparent]`}
  ${tw`mb-2`}
`;

export const StyledEyebrow = styled.span`
  ${tw`block`}
  ${tw`mb-2`}
  ${tw`font-inter font-semi-bold`}
  ${tw`text-primary-p1 text-tag-m uppercase`}
`;

export const StyledInfoContent = styled.div<{ hasDropdown: boolean }>`
  ${({ hasDropdown }) => (hasDropdown ? tw`mb-3` : tw`mb-0 lg:mb-3`)}
`;

export const StyledHeadline = styled.h3`
  ${tw`block`}
  ${tw`font-poppins font-semi-bold`}
  ${tw`text-mobile-heading-l md:text-heading-m text-secondary-s1`}
`;

export const StyledDescription = styled.p`
  ${tw`block`}
  ${tw`font-inter font-regular`}
  ${tw`text-body-l text-primary-p1`}
  ${tw`pt-2`}

  section {
    ${tw`pb-0`}
  }
`;

export const StyledMediaContainer = styled.div`
  ${tw`grid`}
  ${tw`items-center`}
  ${tw`w-full`}
  ${tw`col-span-4 lg:col-span-6 lg:col-start-7`};
`;

export const StyledImageElement = styled(ResponsiveImage)`
  ${tw`w-full`}
  ${tw`rounded-lg`}
`;

export const StyledContainer = styled.div<{
  isImageFullWidth: boolean;
  hasWhiteBackground: boolean;
}>`
  ${tw`gap-5 lg:gap-4`}
  ${tw`grid grid-cols-4 lg:grid-cols-12`}
  ${tw`p-4`}

  &:before {
    ${tw`-z-10`}
    ${tw`content-['']`}
    ${tw`absolute`}
    ${tw`left-0 bottom-0 h-full w-full`}
    ${({ isImageFullWidth }) =>
      isImageFullWidth
        ? tw`lg:w-full bg-gradient-to-b from-[#EEF4FC] to-[#B7D3F2]`
        : tw`lg:w-10/12`}
    ${({ hasWhiteBackground }) => (hasWhiteBackground ? tw`bg-neutrals-n1` : tw`bg-ui-colours-ui1`)}
    ${tw`rounded-2xl`}
  }

  ${({ isImageFullWidth }) => isImageFullWidth && tw`p-2 lg:p-3`}

  ${StyledInfoContainer} {
    ${({ isImageFullWidth }) => isImageFullWidth && tw`hidden`}
  }
  ${StyledMediaContainer} {
    ${({ isImageFullWidth }) => isImageFullWidth && tw`w-full md:col-span-12`}
  }
`;

export const StyledLink = styled(Link)`
  ${tw`self-start`}
  ${tw`mt-2 lg:mt-0`}
`;
